/**
 * LandingRoute — chooses which landing to render at `/`.
 *
 * Reads the `landing_v2_enabled` flag from `FeatureFlagsContext` (the
 * context itself already:
 *   - defaults `landing_v2_enabled` to `false`
 *   - fetches `/api/feature-flags` at boot
 *   - keeps the safe defaults on network failure
 *
 * so this component just picks a component based on the resolved
 * value). If for any reason the flag resolves to a falsy value —
 * including a failed fetch, an admin toggling it off, or a fresh
 * install — the ORIGINAL `Landing` renders. This is the fail-safe
 * reversibility guarantee: the new landing is opt-in, and opting out
 * is instant.
 *
 * Route wiring in `App.js`:
 *   - `/`            → `<LandingRoute />` — conditional
 *   - `/landing-v1`  → `<Landing />`      — always original (compare)
 *   - `/landing-v2`  → `<LandingV2 />`    — always new (compare)
 */
import { useFeatureFlags } from "@/feature-flags/FeatureFlagsContext";
import Landing from "@/pages/Landing";
import LandingV2 from "@/pages/LandingV2";

export default function LandingRoute() {
  const { flags } = useFeatureFlags();
  // Explicit `=== true` so any non-strict-true value (null, undefined,
  // "yes" — impossible from the typed backend, but belt-and-suspenders)
  // falls back to the original landing.
  if (flags?.landing_v2_enabled === true) {
    return <LandingV2 />;
  }
  return <Landing />;
}
